<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar  rounded="" dense color="secondary" elevation="1">
                    <v-breadcrumbs class="ms-n6" :items="breadcrumbsItems" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded="">
                    <v-toolbar color="secondary" flat> 
                        <v-toolbar-title>
                            Edit Item Account
                        </v-toolbar-title>
                        <v-spacer>

                        </v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-delete" tooltip="Delete" @click="handleDelete"/>                            
                            <PIconBtn icon="mdi-undo" tooltip="Cancel" @click="handleCancel"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-progress-linear indeterminate v-if="loading" ></v-progress-linear>
                    <v-divider></v-divider>
                        <v-col cols="12" md="12">
                            <ItemAccountForm 
                                ref="form" 
                                v-model="form" 
                                v-if="!itemLoading"
                                edit
                            />
                        </v-col>
                        <div v-if="itemLoading">
                           <v-col >
                                <v-skeleton-loader
                                    type="text"
                                >
                                </v-skeleton-loader>
                            </v-col>
                            <v-col>
                                <v-skeleton-loader
                                    type="text"
                                >
                                </v-skeleton-loader>
                            </v-col>
                            <v-col>
                                <v-skeleton-loader
                                    type="text"
                                >
                                </v-skeleton-loader>
                            </v-col>
                        </div>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import PAlert from '../../components/common/PAlert.vue'
import PIconBtn from "../../components/common/PIconBtn.vue"
import ItemAccountForm from "../../components/warehouse/ItemAccountForm.vue"
export default {
    name: "ItemAccountEdit",
    components: {
        PIconBtn,
        ItemAccountForm,
        PAlert
    },
    data() {
        return {
            breadcrumbsItems: [
                { text: 'Warehouse & Inventory'},
                { text: 'Account' },
                { text: 'Add Account' }
            ],
            form: null,
            itemLoading: false,
            loading: false,
            itemId: null,
            accountId: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            }
        }
    },
    methods: {
        ...mapActions({
            findByID: "stock/itemAccount/findByID",
            pushItem: "stock/item/search/push",
            snackbar: "ui/snackbar/show",
            update: "stock/itemAccount/update",
            pushAccount: "stock/account/push",
            pushAccountType: "stock/itemAccountType/push",
            remove: "stock/itemAccount/remove"
        }),
        handleSave() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to Save", callback: this.save }
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.update(this.form).then(() => {
                this.snackbar({ text: "Item account updated", color: "success"})
                this.$router.push({ name: "ItemDisplay", params: { id : this.itemId }, query: { tab: 'accounts' }})
            }).catch(error => {
                let message = error.response? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = false;
            })
        },
        fetchItemAccount() {   
            this.itemLoading = true;
            this.findByID({itemId: this.itemId, accountId: this.accountId}).then(response => {
                this.pushItem(response.data.item);
                this.pushAccountType(response.data.item_account_type)
                this.pushAccount(response.data.account)
                this.form = {};
                let data = {
                    ...response.data,
                    item_id: response.data.item.id,
                    item_account_type_id: response.data.item_account_type.id,
                    account_id: response.data.account.id
                }
                this.form = data
            }).finally(() => {
                this.itemLoading = false;   
            })
        },
        handleCancel() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Cancel?", callback: this.cancel};
        },
        cancel() {
            this.$router.push({ name: "ItemDisplay", params: { id : this.itemId }, query: { tab: "accounts" } })
        },
        handleDelete() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to delete?", callback: this.removeItemAccount};
        },
        removeItemAccount() {
            this.loading = true
            this.remove({itemId: this.itemId, accountId: this.accountId}).then(() => {
                this.snackbar({ text: "Item account deleted", color: "success"});                 
                this.$router.push({name: "ItemDisplay", params: {id: this.itemId }, query: { tab: "accounts" }});
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    mounted() {
        if(this.$route.params.id && this.$route.params.accountId) {
            this.itemId = this.$route.params.id;
            this.accountId = this.$route.params.accountId;
            this.fetchItemAccount();
        }
    }
}
</script>

<style>
</style>